const licArrays = (data) =>
{
	const licarr = [];

	console.log('in the licarray function.....', data);

	data.forEach((ele, ind) =>
	{
		const obj = {
			licenseName : '',
			licenseObj  : ''
		};

		if (ele.hosts.length === 0)
		{
			obj.licenseName = `${ele?.licenseName}_${ele?.licenseCount}`;
		}
		else
		{
			obj.licenseName = `${ele?.licenseName}_${ele.hosts[0].license}`;
		}

		obj.licenseObj = ele;

		licarr.push(obj);
	});

	return licarr;
};

export default licArrays;
